<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top fixed-judul">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img src="../../assets/gambar/back-blue.svg" alt="" @click="back">
                </div>
                <div class="col-md-6 col-sm-6 col-6 text-center remove-padding" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                    Data Gaji</div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="animasi-card  bg-transparent d-flex">
                        <div class="font-16 status-login" style="padding: 2px 10px;color: #206CFF">Langkah <span class="font-weight-bold">{{isWebview() ? '3/3' : '4/4'}} </span></div>
                    </div>
                    <form action="">
                        <div class="form-group mar-bottom-24">
                            <div v-for="inputangaji in inputgaji" :key="inputangaji.id">
                                <div v-if="inputangaji.page===1 && inputangaji.id == 1" class="pagesatu">
                                    <label class="remove-margin mar-top-12 color-label font-14" v-bind:for="inputangaji.id">{{inputangaji.text}}</label>
                                    <div class="input-group remove-padding">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16 color-0000 line-height-25 letter-space-002">Rp</div>
                                        </div>
                                        <input type="tel" class="form-control inputs font-16 color-0000 line-height-25 letter-space-002 formgaji" placeholder="14.000" v-bind:id="inputangaji.id" v-on:keyup="inputnumberpokok(inputangaji.id)">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16 color-0000 line-height-25 letter-space-002">{{inputangaji.type}}</div>
                                        </div>
                                    </div>
                                    <div class="font-12 color-6f7 letter-space-002 line-height-18 mar-top-5">Periode dapat ditentukan saat pembayaran gaji</div>
                                </div>

                                <div v-else-if="inputangaji.page===1" class="pagesatu">
                                    <label class="remove-margin mar-top-12 color-label font-14" v-bind:for="inputangaji.id">{{inputangaji.text}}</label>
                                    <div class="input-group remove-padding">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16 color-0000 line-height-25 letter-space-002">Rp</div>
                                        </div>
                                        <input type="tel" class="form-control inputs font-16 color-0000 line-height-25 letter-space-002 formgaji" placeholder="14.000" v-bind:id="inputangaji.id" v-on:keyup="inputnumberpokok(inputangaji.id)">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16 color-0000 line-height-25 letter-space-002">{{inputangaji.type}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else class="pagedua" style="display:none">
                                    <label class="remove-margin mar-top-12 color-label font-14" v-bind:for="inputangaji.id">{{inputangaji.text}}</label>
                                    <div class="input-group remove-padding">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16 color-0000 line-height-25 letter-space-002">Rp</div>
                                        </div>
                                        <input type="tel" class="form-control inputs font-16 formgaji" placeholder="14.000" v-bind:id="inputangaji.id" v-on:keyup="inputnumberpokok(inputangaji.id)">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text font-16 color-0000 line-height-25 letter-space-002">{{inputangaji.type}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="lebih-sedikit text-alignC" @click="showmore" status="1" id="nomore">
                        <div class="remove-padding-margin color-206CF"><span id="text-more">Lihat Lebih Banyak </span><span>
                            <img class="rotate" src="../../assets/icons/chevron-rotate-down.svg" alt="">
                        </span></div>
                    </div>
                    <div class="text-btm mar-top-20 mar-bottom-16" id="text-nb">
                        Anda bisa <b>menambahkan</b> jenis gaji yang lain di menu <b>Pengaturan Gaji</b> dari halaman <b>Detail Karyawan</b>.
                    </div>
                </div>
                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" id="btnNextGaji" @click="post">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="datagaji.isClickeddatagaji === true"></span>
                        <span id="textBtnGaji">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "DataGaji",
        props: ["datagaji"],
        data(){
            return{
                inputgaji:[],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted(){
            this.getjenisgaji()
            $('#more').hide()
            $('#text-nb').hide()
            $('#more-small').hide()

        },
        methods:{
            back(){
                if (this.isWebview()) this.$emit("showdatapekerjaan")
				else this.$emit("showdataakun")
            },
            rotate() {
                $('.rotate').toggleClass("down");
            },
            post(){
                var datagaji = this.inputgaji;
                this.datagaji.datagajitemp = []
                for (var i = 0; i < datagaji.length; i++) {
                    var gajinominal = "";
                    gajinominal = $("#" + datagaji[i].id).val();
                    this.datagaji.datagajitemp.push({idjenis:datagaji[i].id, nominal:gajinominal});
                }

                this.$emit("postkaryawan")
            },
            showmore() {
                var status = $('#nomore').attr('status')
                if (status === '1'){
                    this.rotate()
                    $('.pagedua').slideDown(400)
                    $('#nomore').attr('status','2');
                    $('#text-more').text('Tampilkan lebih sedikit')
                    $('#text-nb').show()
                }else{
                    this.rotate()
                    $('.pagedua').slideUp(400);
                    $('#text-more').text('Lihat lebih banyak')
                    $('#nomore').attr('status','1');
                    $('#text-nb').hide()
                }
            },

            inputnumberpokok(key){
                var handleevent = $('#'+key).val();
                var handlenumber = handleevent.replace(/[^0-9]+/,'');
                $('#'+key).val(handlenumber)
                this.formatrupiah(key)
            },

            formatrupiah(key){
                var rupiah = $('#'+key).val();;
                var formattedrupiah = this.newrupiah(rupiah);
                $('#'+key).val(formattedrupiah)
            },

            newrupiah(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            async getjenisgaji(){
                try {
                    var owner = localStorage.getItem('idowner')
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/jenisgaji_meta?idowner=' + owner, this.requestHeaders)
                    if (response.data.status === true) {
                        var rawtahapan = response.data.data;
                        for (var i = 0; i < rawtahapan.length; i++) {
                            var type ='-'
                            var page = 1
                            if (i >= 3){
                                page = 2
                            }
                            if(rawtahapan[i].type===1){
                                type = 'Per Periode'
                            }
                            else if(rawtahapan[i].type===2){
                                type = 'Perkehadiran'
                            }
                            else if(rawtahapan[i].type===3){
                                type = 'Perjam'
                            }
                            else{
                                type = '-'
                            }
                            this.inputgaji.push({id: rawtahapan[i].id, text: rawtahapan[i].nama ,page: page,type:type})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
        }
    }
</script>

<style scoped>
    .text-btm{
        font-size: 12px;
        line-height: 18px;
        letter-spacing: -0.02em;
        color: rgba(111, 114, 135, 0.65);

    }

    .line-height-18{
        line-height: 18px;
    }

    .letter-space-002{
        letter-spacing: -0.02em;
    }

    .status-login {
        font-size: 14px;
        background: #E2F0FF;
        border-radius: 50px;
        color: #5F95FF;
        padding: 2px 10px;
    }
</style>